import * as React from 'react';
import type { SVGProps } from 'react';

const IconArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 13" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m20.222 1.654-9.865 10.381L.498 1.654l.725-.69 9.136 9.62 9.14-9.62.724.69Z"
    />
  </svg>
);
export default IconArrowDown;
